// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__2YTsA","widget__headline":"Widget_widget__headline__1Ai_s","widget__content":"Widget_widget__content__2aJ09"};